module.exports = __webpack_public_path__ + "static/media/weShare.41c2de2a.png";